import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=def2711c&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=def2711c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def2711c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('def2711c')) {
      api.createRecord('def2711c', component.options)
    } else {
      api.reload('def2711c', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=def2711c&scoped=true&", function () {
      api.rerender('def2711c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-259WRgZTUzYWy/JS/comp/GuestBox.vue"
export default component.exports